<template>
  <div id="product_view">
    <div class="headline">
      <div class="describe">{{ $t("product.PRODUCT_DESCRIPTION") }}</div>
      <div class="title">{{ $t("product.PRODUCT_TITLE") }}</div>
    </div>
    <div class="remain">
      <div class="navbar" :style="{
        'position': scrollTop > StickyHeight ? 'fixed' : 'absolute',
        'top': scrollTop > StickyHeight ? '5rem' : '2rem'
      }">
        <div
          v-for="(nav) in navList"
          :key="nav.title"
        >
          <div @click="scrollToProduct(nav.id)" :class="currentProductId === nav.id ? 'active_nav' : 'navItem' ">
            {{nav.title}}
          </div>
        </div>
      </div>
      <div class="product_content" ref="content">
        <ProductContent @updateProductId="updateProductId"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, markRaw, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import ProductContent from "./pages/ProductContent.vue";
import Mitt from "@/utils/mitt";
import routeHash from '@/constant/router_hash'

const { t } = useI18n();

const StickyHeight = parseFloat(getComputedStyle(document.documentElement).fontSize) * 34

const scrollTop = ref(0)
const content = ref(null)
const navList = computed(() => [
    {
      title: t("product.L2L_NAV"),
      id: "L2L"
    },
    {
      title: t("product.L2A_NAV"),
      id: "L2A"
    },
    {
      title: t("product.RDHx_NAV"),
      id: "RDHx"
    },
    {
      title: t("product.OTHERS_NAV"),
      id: "others"
    },
]);
const currentProductId = ref(navList.value[0].id)

const scrollToProduct = (productId:string) => {
  document.getElementById(productId)?.scrollIntoView({
    behavior: 'smooth',
    block: "start"
  })
}

const updateProductId = (productId:string) => {
  currentProductId.value = productId
}

onMounted(() => {
    window.addEventListener('scroll', function() {  
      scrollTop.value = window.scrollY || document.documentElement.scrollTop;  
  });
  Mitt.on(routeHash.L2A_PRODUCT, () => scrollToProduct("L2A"))
  Mitt.on(routeHash.L2L_PRODUCT, () => scrollToProduct("L2L"))
  Mitt.on(routeHash.RDHx_PRODUCT, () => scrollToProduct("RDHx"))
  Mitt.on(routeHash.OTHERS_PRODUCT, () => scrollToProduct("others"))
})
</script>

<style lang="less" scoped>
#product_view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  animation: fadeIn 1s;
  animation-fill-mode: forwards;
  align-items: center;
  position: relative;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .headline {
    width: 100%;
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 30rem;
    background: #000;
    position: relative;
    background: url("@/assets/product/product_thumbnail.jpg") center center no-repeat;
    background-size: cover;

    .title {
      max-width: var(--view-max-width);
      font-size: var(--primary-title);
      margin-bottom: 1rem;
      overflow: hidden;
      text-align: center;
      margin-top: 0.75rem;
      line-height: 3.8rem;
      color: #fff;
      animation: fadeIn 1s 0.5s forwards;
      opacity: 0;
      font-weight: 700;
      font-family: "HarmonyOS_Bold";
    }

    .describe {
      font-size: var(--primary-text);
      color: #fff;
      animation: fadeIn 1s 0.5s forwards;
      opacity: 0;
    }
  }

  .remain {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-size: cover;
    min-height: 100vh;
    width: 100%;
    background-color: #fff;
    position: relative;

    .navbar {
      position: absolute;
      top: 4rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1.2rem 2rem;
      gap: 4.8rem;
      height: 34px;
      font-size: 1.2rem;
      max-width: calc(var(--view-max-width) + 1rem);
      // margin: 2rem 0;
      border-radius: 100px;
      background-color: rgba(0, 0, 0, 0.1);
      background-position: center center;
      border-color: transparent;
      border-style: solid;
      overflow-y: hidden;
      z-index: 9;

      .navItem {
          color: #222;
          cursor: pointer;
          white-space: nowrap;
      }

      .active_nav {
        color: #002fa5;
        border-bottom: 1px solid #002fa5;
        cursor: pointer;
        white-space: nowrap;
      }
    }

  }
}
</style>